import { Route, Routes } from "react-router-dom";
import { LoginScreen } from "./LoginScreen";
import { QrLoginScreen } from "./QrLoginScreen";
import { RegisterScreen } from "./RegisterScreen";
import { EmailLoginScreen } from "./EmailLoginScreen";
import { PasswordResetScreen } from "./PasswordResetScreen";
import { EmailRegisterScreen } from "./EmailRegisterScreen";

export const AuthPageRoutes = () => (
  <Routes>
    <Route path="login" element={<LoginScreen />} />
    <Route path="qr-login" element={<QrLoginScreen />} />
    <Route path="email-login" element={<EmailLoginScreen />} />
    <Route path="password-reset" element={<PasswordResetScreen />} />
    <Route path="register" element={<RegisterScreen />} />
    <Route path="email-register" element={<EmailRegisterScreen />} />
  </Routes>
);
